module.exports = __webpack_public_path__ + "img/icon-informatiquenews.17642412.png";